import {Body, Header} from "./parts";

export const Upload = () => {

  return (
    <>
      <Header />
      <Body />
    </>
  )
}